import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Leistungen', path: '/leistungen' },
    { name: 'Portfolio', path: '/portfolio' },
    { name: 'Blog', path: '/blog' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Über uns', path: '/ueber-uns' },
    { name: 'Kontakt', path: '/kontakt' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        isScrolled ? 'bg-black/90 backdrop-blur-md border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-[7.6923%] py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <img
            src="https://customer-assets.emergentagent.com/job_3dc7acc6-cad7-4ff2-a881-71992e987d42/artifacts/i4tnc7pr_IMG_1216.png"
            alt="Zonik Solutions Logo"
            className="h-12 w-auto object-contain"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-lg font-normal transition-colors duration-300 ${
                location.pathname === link.path
                  ? 'text-[#FF4444]'
                  : 'text-[#4D4D4D] hover:text-white'
              }`}
            >
              {link.name}
            </Link>
          ))}
          <Link to="/projekt-anfragen">
            <Button className="bg-[#FF4444] text-black hover:bg-white hover:text-black border-0 rounded-md px-6 py-3 h-auto text-lg font-medium transition-all duration-300">
              Projekt anfragen
            </Button>
          </Link>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-white p-2"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black border-t border-white/10">
          <nav className="flex flex-col gap-4 p-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`text-lg font-normal transition-colors duration-300 ${
                  location.pathname === link.path
                    ? 'text-[#FF4444]'
                    : 'text-[#4D4D4D] hover:text-white'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/projekt-anfragen" onClick={() => setIsMobileMenuOpen(false)}>
              <Button className="bg-[#FF4444] text-black hover:bg-white hover:text-black border-0 rounded-md px-6 py-3 h-auto text-lg font-medium w-full transition-all duration-300">
                Projekt anfragen
              </Button>
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;